<template>
  <div id="app">
    <!-- <lastWorks v-if="!isHome" />  -->
    <!-- <Home />  -->
    <!-- <ways /> -->
    <create-together />
  </div>
</template>

<script>
// import lastWorks from '@/views/lastWorks'
// import Home from '@/views/Home'
// import ways from '@/views/ways2020'
import CreateTogether from '@/views/create'

export default {
  name: 'App',
  components: {
    // lastWorks,
    // Home,
    // ways,
    CreateTogether
  },
  data () {
    return {
      isHome: true
    }
  }
}
</script>

<style lang='scss'>
html{
  -webkit-text-size-adjust:none !important;
}
br {
  opacity: 0;
}
body {
  font-family: sans-serif;
  /* font-family: "SimSun"; */
  color: #242933;
  outline: none;
  overflow-x: hidden;
}
video{
  outline: none;
}
#app{
    overflow-x: hidden;
}
.el-message--error,
.el-message--success,
.el-message--warning {
  // border:1px dashed  balck;
  min-width: 100px !important;
  background-color: #000;
  filter: alpha(opacity=60);
  background-color: rgba(0, 0, 0, 0.6) !important;
  color: #fff !important;
  border: none;
  // position: absolute;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
  // margin-top: 0;
  .el-message__content {
    color: #fff !important;
  }
  .el-message__icon {
    display: none;
  }
}
</style>
